import { render, staticRenderFns } from "./m-tabbar.vue?vue&type=template&id=13a380b4&scoped=true&"
import script from "./m-tabbar.vue?vue&type=script&lang=js&"
export * from "./m-tabbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a380b4",
  null
  
)

export default component.exports